import { z } from 'zod';
import { Money } from './money';

const ItemSnap = z.object({
  itemId: z.string(),
  productId: z.string().nullable(),
  name: z.string(),
  qty: z.number(),
  unitPrice: Money,
  modifiers: z.array(z.object({ name: z.string(), priceDelta: Money })),
  /** уже на кухне — при подхвате стола второй раз не поедет */
  fired: z.boolean().optional(),
});

export const UpsertOpenOrder = z.object({
  orderId: z.string(),
  tableId: z.string(),
  tableName: z.string(),
  number: z.number().int(),
  openedAt: z.string().datetime(),
  items: z.array(ItemSnap).min(1).max(200),
  discount: Money.default(0),
  guestPhone: z.string().optional(),
  /** счёт напечатан — стол переходит в ожидание денег */
  precheck: z.boolean().optional(),
  /** отправлено на кухню — стол больше нельзя освободить сам собой */
  fired: z.boolean().optional(),
  /**
   * Вернуть стол прежнему официанту, а не записать на себя.
   * Кассир открыл чужой стол, увидел ошибку и отдаёт назад —
   * заказ должен остаться в его выручке, а не переехать к кассиру
   */
  keepOwner: z.string().optional(),
});
export type UpsertOpenOrder = z.infer<typeof UpsertOpenOrder>;

export const OpenOrderRow = UpsertOpenOrder.extend({
  openedById: z.string(),
  openedByName: z.string(),
  updatedAt: z.string().datetime(),
  // default(0) в Upsert делает поле опциональным на выводе —
  // в строке ответа скидка всегда есть
  discount: Money,
  /** счёт напечатан — стол ждёт денег, и кассир видит это в списке */
  awaitingPay: z.boolean(),
  precheckAt: z.string().nullable(),
});
export const OpenOrdersList = z.object({ rows: z.array(OpenOrderRow) });
export type OpenOrdersList = z.infer<typeof OpenOrdersList>;
export type OpenOrderRow = z.infer<typeof OpenOrderRow>;
